export const TABLE_HEADER_ROW_PADDING_X = '4px';
export const TABLE_HEADER_ROW_PADDING_Y = '2px';
export const TABLE_HEADER_ROW_FONT_SIZE = '13.5px';

export const SPOT_TABLE_ROW_PADDING_Y = '0.5px';
export const FUTURES_TABLE_ROW_PADDING_Y = '0.5px';
export const OPTIONS_TABLE_ROW_PADDING_Y = '0.5px';
export const ORDERS_TABLE_ROW_PADDING_Y = '0.5px';
export const POSITIONS_TABLE_ROW_PADDING_Y = '0.5px';
export const TABLE_ROW_PADDING_X = '4px';

export const TABLE_PARAMETER_COLUMN_MIN_WIDTH = '30px';
export const TABLE_ROW_FONT_SIZE = '13.5px';
export const TABLE_SYMBOL_EXP_CELL_FONT_SIZE = '13px';
export const TABLE_EXPIRATION_EXP_CELL_FONT_SIZE = '13.5px';
export const TABLE_EXPIRATION_PRICE_UNAVAILABLE_TEXT = '······';
